import React, {useEffect, useMemo, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {addUserToDialogue, dialogueAsyncActions, getDialogue, getTranslations} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import {ReactComponent as ChatIcon} from 'assets/image/menu-auth/chat.svg';

import './styles.scss';
import {Link, useParams} from 'react-router-dom';
import {BotMode} from '@wholesalechange/chatcomponent';

export const ChatroomChat: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    dialogue, participant
  } = useSelector((state: IStore) => state.dialogue);
  const {
    userProfile, settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const shouldLoad = useRef(true);
  const {dialogueId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogueId && userProfile) {
      if (shouldLoad.current) {
        shouldLoad.current = false;
        dispatch(dialogueAsyncActions[addUserToDialogue](userProfile.id, Number(dialogueId)));
        dispatch(dialogueAsyncActions[getDialogue](Number(dialogueId)));
      }
    }
  }, [dialogueId, userProfile]);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Chatroom.toLowerCase());

    return page?.translationKey || TranslationKeys.Chatroom;
  }, [settings]);

  useGetTranslations({translationKey});

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Chatroom.toLowerCase());

    return page?.title || Pages.Chatroom;
  }, [settings]);

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/chatroom">
        <FormattedMessage
          id={`gritx.common.navigation.${title}`}
          defaultMessage={title}
        />
      </Link> {dialogue && <span className="chatroom-chat__title-dialogue-name"> - {dialogue.name}</span>}
    </div>;
  }

  return <div className="chatroom-chat">
    {
      !loading.includes(getTranslations) && dialogue && participant && <>
        <h1 className="chatroom-chat__title">
          <ChatIcon className="chatroom-chat__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat chatType={BotType.Dialogue} chatMode={BotMode.FullHistory} dialogueId={dialogue.id} title={dialogue.name}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false} />
      </>
    }
  </div>;
};
